<template>
    <div
        :class="[
            showInfo ? 'showTemplate' : 'hiddenTemplate',
            'print-template',
        ]"
    >
        <!-- 基础内容 -->
        <template v-if="enrolInfo.enrollTitle">
            <h3 v-if="enrolInfo.enrollTitle">{{ enrolInfo.enrollTitle }}</h3>
        </template>
        <template v-else="enrolInfo.examTitle">
            <h3>{{ enrolInfo.examTitle }}</h3>
        </template>

        <div class="postName" v-if="enrolInfo.postName">申请岗位:{{enrolInfo.postName}}</div>
        <table>
            <tbody>
                <tr>
                    <td>
                        姓名
                    </td>
                    <td colspan="2">
                        {{ info.fullName }}
                    </td>
                    <td>
                        性别
                    </td>
                    <td>
                        {{ info.gender == 1 ? '男' : '女' }}
                    </td>

                    <td colspan="2">
                        民族
                    </td>
                    <td colspan="3">
                        {{ info.nation }}
                    </td>

                    <td rowspan="4" width="140px">
                        <img :src="getUrl(info.photograph)" />
                    </td>
                </tr>

                <tr>
                    <td>
                        出生年月
                    </td>
                    <td colspan="2">
                        {{ info.birthday }}
                    </td>
                    <td>
                        籍贯
                    </td>
                    <td>
                        {{ info.origo }}
                    </td>

                    <td colspan="2">
                        婚姻状况
                    </td>
                    <td colspan="3">
                        {{ info.birthPlace }}
                    </td>
                </tr>

                <tr>
                    <td>
                        户口所在地
                    </td>
                    <td colspan="2">
                        {{ info.domicilePlace }}
                    </td>
                    <td>
                        政治面貌
                    </td>
                    <td>
                        {{ info.politicalStatus }}
                    </td>

                    <td colspan="2">
                        身份证号码
                    </td>
                    <td colspan="3">
                        {{ info.idNumber }}
                    </td>
                </tr>

                <tr>
                    <td>
                        身高(cm)
                    </td>
                    <td colspan="2">
                        {{ info.height }}
                    </td>
                    <td>
                        体重(kg)
                    </td>
                    <td>
                        {{ info.weight }}
                    </td>

                    <td colspan="2">
                        档案保管单位
                    </td>
                    <td colspan="3">
                        {{ info.health }}
                    </td>
                </tr>

                <tr>
                    <td>
                        第一学历
                    </td>
                    <td>
                        {{ info.firstQualifications }}
                    </td>
                    <td>
                        学历性质
                    </td>

                    <td>
                        {{
                            info.firstQualificationsProperty
                                | EducationStatusFilter
                        }}
                    </td>

                    <td>
                        毕业学校
                    </td>
                    <td>
                        {{ info.firstQualificationSchools }}
                    </td>

                    <td>
                        专业
                    </td>
                    <td>
                        {{ info.firstQualificationMajors }}
                    </td>

                    <td colspan="2">
                        毕业时间
                    </td>
                    <td>
                        {{ info.firstQualificationGraduationTime }}
                    </td>
                </tr>

                <tr v-if="info.firstQualificationsProperty === 4">
                    <td>
                        学历性质说明:
                    </td>
                    <td colspan="9">
                        {{ info.firstQualificationsPropertyDesc }}
                    </td>
                </tr>

                <tr>
                    <td>
                        最高学历
                    </td>
                    <td>
                        {{ info.highestQualification }}
                    </td>

                    <td>
                        学历性质
                    </td>
                    <td>
                        {{
                            info.highestQualificationsProperty
                                | EducationStatusFilter
                        }}
                    </td>
                    <td>
                        毕业学校
                    </td>
                    <td>
                        {{ info.highestQualificationSchools }}
                    </td>

                    <td>
                        专业
                    </td>
                    <td>
                        {{ info.highestQualificationMajors }}
                    </td>

                    <td colspan="2">
                        毕业时间
                    </td>
                    <td>
                        {{ info.highestQualificationGraduationTime }}
                    </td>
                </tr>

                <tr v-if="info.highestQualificationsProperty === 4">
                    <td>
                        学历性质说明:
                    </td>
                    <td colspan="10">
                        {{ info.highestQualificationsPropertyDesc }}
                    </td>
                </tr>

                <tr>
                    <td>
                        职称、执（职）业资格及取得时间
                    </td>
                    <td colspan="10">
                        <el-input
                            type="textarea"
                            disabled
                            :autosize="{ minRows: 4 }"
                            v-model="info.certificate"
                        ></el-input>
                    </td>
                </tr>

                <tr>
                    <td>
                        有何特长
                    </td>
                    <td colspan="4">
                        {{ info.foreignLanguage }}
                    </td>

                    <td>
                        是否有驾照
                    </td>
                    <td colspan="5">
                        {{ info.drivingLicense == 1 ? '有' : '无' }}
                    </td>
                </tr>

                <tr>
                    <td>
                        通信地址
                    </td>
                    <td colspan="10">
                        {{ info.address }}
                    </td>

                    <!-- <td>
            邮政编码
          </td>
          <td colspan="2">
            {{info.postCode}}
          </td> -->
                </tr>

                <tr>
                    <td>
                        手机及固定手机号码
                    </td>
                    <td colspan="4">
                        {{ info.phone }}
                    </td>

                    <td>
                        电子邮箱
                    </td>
                    <td colspan="5">
                        {{ info.email }}
                    </td>
                </tr>

                <tr>
                    <td>
                        其他联系人
                    </td>
                    <td colspan="4">
                        {{ info.otherLinkman }}
                    </td>

                    <td>
                        其他联系人号码
                    </td>
                    <td colspan="5">
                        {{ info.otherLinkmanPhone }}
                    </td>
                </tr>

                <tr>
                    <td>
                        工作年限(年)
                    </td>
                    <td colspan="10">
                        {{ info.workExperience }}
                    </td>
                </tr>

                <tr>
                    <td
                        :rowspan="info.workHistory.length + 1"
                        class="addRowPanel"
                    >
                        工作经历
                        <p>(从最近工作经历写起)</p>
                    </td>
                    <td class="title" width="80px">开始时间</td>
                    <td width="80px">结束时间</td>
                    <td>工作年限</td>
                    <td>工作单位</td>
                    <td>工作职位</td>
                    <td colspan="2">工作内容</td>
                    <td>工作状态</td>
                    <td>证明人</td>
                    <td>证明人联系方式</td>
                </tr>
                <tr v-for="(work, $index) in info.workHistory" class="eidtItem">
                    <td>
                        {{ work.startTime }}
                    </td>
                    <td>
                        {{ work.endTime }}
                    </td>
                    <td>
                        {{ month_between(work.startTime, work.endTime) }}
                    </td>
                    <td>
                        {{ work.company }}
                    </td>
                    <td>
                        {{ work.plant }}
                    </td>
                    <td colspan="2">
                        {{ work.workContent }}
                    </td>
                    <!-- 状态过滤 -->
                    <td>
                        {{ work.status == 1 ? '至今在职' : '已离职' }}
                    </td>
                    <td>
                        {{ work.witness }}
                    </td>
                    <td>
                        {{ work.witnessPhone }}
                    </td>
                </tr>

                <tr>
                    <td>
                        与应聘岗位相关的实践经历或取得的成绩
                    </td>
                    <td colspan="10">
                        <el-input
                            type="textarea"
                            disabled
                            :autosize="{ minRows: 4 }"
                            v-model="info.projectHistory"
                        ></el-input>
                    </td>
                </tr>

                <tr>
                    <td>
                        自我评价
                    </td>
                    <td colspan="10">
                        {{ info.selfAssessment }}
                    </td>
                </tr>

                <tr>
                    <td
                        :rowspan="info.familyMembers.length + 1"
                        class="addRowPanel"
                    >
                        <p>家庭成员及主要社会关系</p>
                        <p>(至少需要填写父母情况)</p>
                    </td>
                    <td class="title" colspan="2">
                        称谓
                    </td>
                    <td colspan="2">
                        姓名
                    </td>
                    <td>
                        年龄
                    </td>
                    <td colspan="5">
                        现工作单位及职务
                    </td>
                </tr>
                <tr
                    v-for="(item, $index) in info.familyMembers"
                    class="eidtItem"
                >
                    <td colspan="2">
                        {{ item.appellation }}
                    </td>
                    <td colspan="2">
                        {{ item.fullName }}
                    </td>
                    <td>
                        {{ item.age }}
                    </td>
                    <td colspan="5">
                        {{ item.companyAndPost }}
                    </td>
                </tr>

                <tr>
                    <td>备注</td>
                    <td colspan="10">
                        {{ info.otherDescription }}
                    </td>
                </tr>

                <tr
                    v-for="(extraFiled, $index) in extraFields"
                    class="extraFields eidtItem"
                >
                    <td>
                        {{ extraFiled.fieldName }}
                    </td>
                    <td colspan="10">
                        {{ info.attr[extraFiled.fieldCode] }}
                    </td>
                </tr>

                <tr>
                    <td>应聘人承诺</td>
                    <td colspan="4" class="print-sign-bottom">
                        <p>
                            本人承诺所提供的材料真实有效，符合应聘岗位所需的资格条件。如有弄虚作假，承诺主动放弃考试和聘用资格(请考生按照报名表要求在对应的栏目填写相关信息，未按栏目要求填写信息的将导致资格审查不通过，后果由考生自行承担)
                        </p>
                        <p>应聘人签名:</p>
                        <p class="sign-date">
                            <span>年</span><span>月</span><span>日</span>
                        </p>
                    </td>

                    <td>资格审查意见</td>
                    <td colspan="5" class="print-sign-bottom">
                        <p>经审查，符合应聘资格条件。</p>
                        <p>
                            <span>审查人签名:</span
                            ><span style="float:right">招聘单位(章)</span>
                        </p>
                        <p class="sign-date">
                            <span>年</span><span>月</span><span>日</span>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import FileUrlMixin from '@/mixins/FileUrlMixin';
function MonthsBetw(date1, date2) {
    //用-分成数组
    date1 = date1.split('-');
    date2 = date2.split('-');
    //获取年,月数
    var year1 = parseInt(date1[0]),
        month1 = parseInt(date1[1]),
        year2 = parseInt(date2[0]),
        month2 = parseInt(date2[1]),
        //通过年,月差计算月份差
        months = (year2 - year1) * 12 + (month2 - month1) + 1;
    return months;
}
export default {
    mixins: [FileUrlMixin],
    props: {
        info: Object,
        extraFields: {
            type: Array,
            default: () => {
                return [];
            },
        },
        showInfo: false,
        enrolInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    methods: {
        // 计算工作年限
        month_between(_startDate, _endDate) {
            if (_startDate && _endDate) {
                let monthNumber = MonthsBetw(_startDate, _endDate);
                if (monthNumber < 0) {
                    return '';
                }
                let yearNumber = parseFloat(monthNumber / 12).toFixed(1);
                return `${yearNumber}年(${monthNumber}个月)`;
            }
            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
$table-border: #cac4c4;
.print-template {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    table {
        text-align: left;
        color: black;
    }
    h3 {
        text-align: center;
        color: black;
    }
    .postName{
      margin:10px 0;
    }
}
.showTemplate {
    opacity: 1;
}
.hiddenTemplate {
    opacity: 1;
}
table {
    font-size: 12px;
    width: 100%;
    color: #827d7d;
    border-spacing: 0;
    border-right: 1px solid $table-border;
    border-bottom: 1px solid $table-border;
    td {
        border-left: 1px solid $table-border;
        border-top: 1px solid $table-border;
        padding: 2px 4px;
    }
    :global(textarea) {
        color: inherit !important;
        padding: 0 2px;
        background-color: transparent;
        border: 0;
        border-radius: 0;
        resize: none;
        font-size: 12px;
    }
}
img {
    width: 100%;
    height: 170px;
}
.print-sign-bottom {
    position: relative;
    padding-bottom: 40px;
    .sign-date {
        position: absolute;
        right: 0;
        bottom: 0;
        span {
            margin-right: 30px;
        }
    }
}
</style>
